import React, { useMemo } from "react";
import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { CustomNoRowsOverlay } from "../../../../components/common/OverlayGrid";
import { commonDataGridSx } from "../../../../components/common/commonDataGridStyles";

const AgeingSummary = ({ ageingList = [], isLoading = false }) => {
  const ageingColumns = useMemo(
    () => [
      {
        field: "bucket",
        headerName: "Bucket",
        flex: 1,
        minWidth: 130,
        renderCell: (params) => (
          <span
            style={{
              fontWeight: params.row.isDanger ? 700 : 500,
              color: params.row.isDanger ? "#dc2626" : "inherit",
            }}
          >
            {params.value}
          </span>
        ),
      },
      {
        field: "amount",
        headerName: "Amount",
        flex: 1,
        minWidth: 120,
        headerAlign: "right",
        align: "right",
        renderCell: (params) => (
          <span
            style={{
              fontWeight: params.row.isDanger ? 700 : 500,
              color: params.row.isDanger ? "#dc2626" : "inherit",
            }}
          >
            ₹{params.value}
          </span>
        ),
      },
      {
        field: "receipts",
        headerName: "Receipts",
        flex: 0.8,
        minWidth: 100,
        headerAlign: "center",
        align: "center",
        renderCell: (params) => (
          <span
            style={{
              fontWeight: params.row.isDanger ? 700 : 500,
              color: params.row.isDanger ? "#dc2626" : "inherit",
            }}
          >
            {params.value}
          </span>
        ),
      },
      {
        field: "meaning",
        headerName: "What it usually means",
        flex: 2.8,
        minWidth: 360,
        renderCell: (params) => (
          <span
            style={{
              fontWeight: params.row.isDanger ? 600 : 400,
              color: params.row.isDanger ? "#dc2626" : "#64748b",
            }}
          >
            {params.value}
          </span>
        ),
      },
    ],
    []
  );

  const ageingRows = useMemo(() => {
    if (Array.isArray(ageingList) && ageingList.length > 0) {
      return ageingList.map((item, idx) => {
        const isDanger = String(item.bucket || "").toLowerCase().includes("60");
        return {
          id: idx + 1,
          bucket: item.bucket || "—",
          amount: Number(item.amount || 0).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }),
          receipts: item.receipts || 0,
          meaning: item.note || "—",
          isDanger,
        };
      });
    }
    return [];
  }, [ageingList]);

  return (
    <div className="card border rounded shadow-sm mb-4">
      <div className="card-header bg-white py-3 border-bottom d-flex align-items-center gap-2">
        <span
          className="rounded-circle"
          style={{
            width: "12px",
            height: "12px",
            backgroundColor: "rgb(4, 161, 137)",
          }}
        ></span>
        <span className="fw-semibold" style={{ fontSize: "14px" }}>
          Ageing Summary
        </span>
      </div>
      <Box sx={{ width: "100%", backgroundColor: "#fff" }}>
        <DataGrid
          rows={ageingRows}
          columns={ageingColumns}
          loading={isLoading}
          autoHeight
          hideFooter
          disableColumnMenu
          disableRowSelectionOnClick
          getRowId={(row) => row.id}
          rowHeight={48}
          slots={{
            noRowsOverlay: CustomNoRowsOverlay,
          }}
          sx={commonDataGridSx}
        />
      </Box>
    </div>
  );
};

export default AgeingSummary;
